import { Modal } from 'antd';
import moment from 'moment';
import { forwardRef, useImperativeHandle, useState } from 'react';
import aptActions from 'services/actions/apt';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import AptByCustomerTable, { customerTableLoading } from './AppointmentByCustomer';
import CustomerSearch from '.';
import CustomerSearchInput from './CustomerSearchInput';
import { ICustomerUI } from 'types/customer';
import Box from 'components/Box';
export type ModalCustomerAppointmentRef = {
  open: (_value: ICustomerUI | null) => void;
};
const DATE_FORMAT = 'YYYY-MM-DD';
const ModalCustomerAppointments = forwardRef<ModalCustomerAppointmentRef>((_, ref) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [customer, setCustomer] = useState<ICustomerUI | null>(null);

  const setValue = (_value: ICustomerUI | null) => {
    setCustomer(_value);
    const start_time = moment().format(DATE_FORMAT);
    const customerId = _value?.id?.toString() || '';
    if (customerId)
      return dispatch(aptActions.customer.initData({ customerId, start_time }));
    dispatch(aptActions.customer.clear());
  };

  const handleOpen: ModalCustomerAppointmentRef['open'] = (_value) => {
    setOpen(true);
    setValue(_value);
  };

  const onCancel = () => setOpen(false);
  useImperativeHandle(ref, () => ({
    open: handleOpen
  }));

  return (
    <Modal closable={false} closeIcon={null} open={open} onCancel={onCancel} width={'auto'} centered footer={null}>
      <Header>Customer Appointments</Header>
      <Box display='flex' flexDirection='column' gap='2' p='2'>
        <CustomerSearchInput
          v2NewApt
          preventUnknown
          autoOpenAddWhenNotFound
          v2
          value={customer}
          onChange={setValue}
        />
        <AptByCustomerTable />
      </Box>
      <Footer>
        <button type="button" onClick={onCancel} className="btn">
          Close
        </button>
      </Footer>
    </Modal>
  );
});
ModalCustomerAppointments.displayName = 'ModalCustomerAppointments';
export default ModalCustomerAppointments;
const Footer = styled.div`
  zoom: 0.8;
  display: flex;
  padding: 12px 24px 32px 24px;
  justify-content: space-between;
  gap: 12px;
  align-self: stretch;
  background: #fff;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.1);
  .btn {
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    border-radius: 4px;
    background: #d4d7e4;
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
    &:hover {
      opacity: 0.8;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &.btn-submit {
      background: #148cf1;
      color: #fff;
    }
    &.btn-orange {
      background: #f05326;
      color: #fff;
    }
    &.btn-green {
      background: #0cb76f;
      color: #fff;
    }
    &.btn-black {
      background: #232f3e;
      color: #fff;
    }
  }
`;

const Header = styled.div`
  zoom:0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;

  border-radius: 5px;
  border-bottom: 1px solid #d4d7e4;
  background: #232f3e;

  color: #fff;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
`;
